'use client';

import { useTranslations, useLocale } from 'next-intl';
import React from 'react';

import { useDomainConfiguration } from '@/components/DomainConfigurationProvider';

const PartnerLogosSection: React.FC = () => {
    const t = useTranslations();
    const locale = useLocale();
    const { domainConfiguration } = useDomainConfiguration();

    const partners = domainConfiguration.partners;
    if (!partners?.length) {
        return null;
    }

    const headline = domainConfiguration.partnerHeadline?.[locale] || t('partners.title');

    return (
        <section
            className="py-[56px]"
            id="partners">
            <h2 className="text-headline-24 lg:text-headline-32 text-center tracking-[0.75px] mb-[24px]">{headline}</h2>
            <div className="flex flex-wrap items-center justify-center gap-[24px] lg:gap-[48px]">
                {partners.map((partner) => {
                    const logo = (
                        // eslint-disable-next-line @next/next/no-img-element
                        <img
                            src={partner.logoUrl}
                            alt={t('partners.logo-alt', { name: partner.name })}
                            className="h-[48px] lg:h-[72px] w-auto max-w-[200px] object-contain"
                        />
                    );

                    if (partner.link) {
                        const href = partner.link.startsWith('http') ? partner.link : `https://${partner.link}`;
                        return (
                            <a
                                key={partner.name}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="transition-opacity hover:opacity-80">
                                {logo}
                            </a>
                        );
                    }

                    return <div key={partner.name}>{logo}</div>;
                })}
            </div>
        </section>
    );
};

export default PartnerLogosSection;
